// extracted by mini-css-extract-plugin
export default {"confirmation-indicator":"LiveLinkingIndicator_confirmation-indicator__Ow8Ty"};